export enum categoryEnum {
  officeAMLPolicy = "Office AML policy",
  customerIdentificationForCompany = "Customer Identification: Company",
  customerIdentificationForPrivatePerson = "Customer Identification: Private Person",
  customerAcceptanceProcedureLight = "Customer Acceptance Procedure Light",
  customerAcceptanceProcedure = "Customer Acceptance Procedure",
  whistleBlowing = "Whistleblowing",
  notificationCFI = "Notification CFI",
  yearlyReport = "Yearly Report",
  yearlyActivityReport = "Yearly activity report",
  reportAtypicalOperation = "Report Atypical Operation",
  verification = "Verification",
  renewalIdCardPrivatePerson = "Renewal ID Card Private Person",
  idCardRenewal = "ID Card Renewal"
}
